import React, { useEffect, useState } from 'react'
import PlantillaScreen from '../../helpers/PlantillaScreen'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { useBoxFiltros } from '../../CreditoyCobranza/ReporteCobranza/Helper/useBox';
import { GetKeyArray } from '../../../Helpers/GetKey';
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import { LoaderScreen } from '../../components/LoaderScreen';
import { FiltroConfListadoPrecio } from '../ConfiguracionListado/FiltroConfListadoPrecio';
import { TablaConfImagenContainer } from './TablaConfImagenContainer';
import { FiltroBuscadoListadoPrecio } from '../../Usados/Inventario/FiltroBuscadorListadoPrecio';

export const ConfiguracionImagenesScreen = () => {
    const history = useHistory();
    const [filtroEstado, setFiltroEstado] = useState(false);
    const [keyFiltrado, setKeyFiltrado] = useState("")
    const [boxstate, setBoxState] = useBoxFiltros();
    const [state, setState] = useState({
        resumen: {},
        data: [],
    });
    const [data, setData] = useState([])
    const [datafiltro, setDatafiltro] = useState([])
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // console.log(datafiltro)

    useEffect(() => {
        ObtenerListado()
    }, []);

    const ObtenerListado = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ListadoPreciosProductoAliado/ListadoFiltro`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result);
                setDatafiltro(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                return;
            });
    }

    const onGeneraPDF = (datos) => {
        const mdl = (datos);
        // console.log(mdl)
        request
            .post("Inventario/ImprimirPDF", mdl)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const handleFiltrar = async () => {
        setFiltroEstado(true); // Activa la señal para la tabla
    };

    return (
        <PlantillaScreen
            titulo={"LISTADO DE IMAGENES POR PRODUCTO"}
            className_main={1}
            className={"paliado-listado-precios-main-screen"}
        >
            <LoaderScreen loader={loader} />
            <div className='paliado-Contenedor-lista-precios-usado'>
                <div className="listado-precios-botones-pagina-container">
                    <div
                        className="listado-precios-actions-regresar"
                        onClick={() => history.push("/ProductoAliado/Main")}
                    >
                        <ArrowBackIcon />
                        Regresar
                    </div>
                    {/* <div className="buttons">
                        <button className="PDF"
                            onClick={() =>
                                onGeneraPDF(datafiltro)
                            }
                            style={{ backgroundColor: '#940404' }}>
                            PDF
                        </button>
                    </div> */}
                </div>
                {/* <FiltroConfListadoPrecio
                    data={data}
                    datafiltro={datafiltro}
                    setDatafiltro={setDatafiltro}
                    filtrar={filtroEstado}
                    setFiltrar={setFiltroEstado}
                    keyFiltrado={keyFiltrado}
                /> */}
                <FiltroBuscadoListadoPrecio
                    data={data}
                    datafiltro={datafiltro}
                    setDatafiltro={setDatafiltro}
                    filtrar={filtroEstado}
                    setFiltrar={setFiltroEstado}
                    keyFiltrado={keyFiltrado}
                />
                <TablaConfImagenContainer
                    datos={datafiltro}
                    ObtenerListado={ObtenerListado}
                    filtrar={filtroEstado}
                    setFiltrar={setFiltroEstado}
                    setKeyFiltrado={setKeyFiltrado}
                />
            </div>
        </PlantillaScreen>
    )
}
